<template>
  <div v-if="bannerVisible"
    id="quote-banner"
    class="quote-banner mb-2"
    :class="bannerClass">
    <div class="quote-banner-icon">
      <span class="material-symbols-rounded mr-8">{{ iconClass }}</span>
    </div>
    <div class="quote-banner-content">
      <span class="has-text-weight-bold is-size-8">{{ title }}</span>
      <span class="is-size-7">{{ message }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuoteBanner',
  props: {
    bannerVisible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: 'Quote Editing Locked'
    },
    message: {
      type: String,
      default: 'Editing is disabled while a payment authorisation is in progress.'
    },
    type: {
      type: String,
      default: 'warning' // warning, danger, info, success
    },
    icon: {
      type: String,
      default: '' // optional override
    }
  },
  computed: {
    bannerClass() {
      const typeMap = {
        warning: 'has-background-warning is-warning has-text-dark',
        danger: 'has-background-danger is-danger has-text-white',
        info: 'has-background-info is-info has-text-dark',
        success: 'has-background-success is-success has-text-white'
      }
      return typeMap[this.type] || typeMap['warning']
    },
    iconClass() {
      if (this.icon) return this.icon
      const iconMap = {
        warning: 'warning',
        danger: 'dangerous',
        info: 'info',
        success: 'check_circle'
      }
      return iconMap[this.type] || iconMap['warning']
    }
  }
}
</script>

<style lang="scss" scoped>
.quote-banner {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.8rem;
  padding: 0 0.8rem;
  gap: 1rem;
  z-index: 100;
}

.quote-banner-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.quote-banner-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  line-height: 1.5;
}
</style>
